import React, { useState } from 'react';
import { Grid, ToggleButtonGroup, ToggleButton, useTheme } from '@mui/material';
import { QuestionSetProps } from './questionSet.interface';
import { useCustomTranslation } from '../../../../../../translation/customTranslation';

export function ToggleQuestion({
  questionList,
  data,
  onAnswerSelect,
}: QuestionSetProps) {
  const { t } = useCustomTranslation('assessment');
  const theme = useTheme();
  const [selectedValue, setSelectedValue] = useState(new Map());

  const handleSingleSelection = (key: string, value: string) => {
    setSelectedValue(new Map(selectedValue.set(key, value)));
    onAnswerSelect(key, value);
  };

  const getSelected = (key: string, value: string) => {
    if (data && data[key] === value) {
      return true;
    }
    return selectedValue.get(key) === value;
  };

  return (
    <>
      {questionList?.map((question: any) => {
        return (
          <Grid
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            key={question.key}
            sx={{ mt: 2 }}
          >
            {t(question.label)}

            <ToggleButtonGroup
              aria-label={question.key}
              exclusive
              onChange={(event, _value) =>
                handleSingleSelection(question.key, _value)
              }
            >
              <ToggleButton
                key={t('ID_GENERIC_NO')}
                value={t('ID_GENERIC_NO')}
                aria-label={t('ID_GENERIC_NO')}
                size="small"
                sx={{
                  minWidth: 50,
                  '&.Mui-selected, &.Mui-selected:hover': {
                    color: theme.palette.primary.contrastText,
                    backgroundColor: theme.palette.primary.light,
                    opacity: 0.8,
                  },
                }}
                selected={getSelected(question.key, t('ID_GENERIC_NO'))}
              >
                {t('ID_GENERIC_NO')}
              </ToggleButton>

              <ToggleButton
                key={t('ID_GENERIC_YES')}
                value={t('ID_GENERIC_YES')}
                aria-label={t('ID_GENERIC_YES')}
                size="small"
                sx={{
                  minWidth: 50,
                  '&.Mui-selected, &.Mui-selected:hover': {
                    color: theme.palette.primary.contrastText,
                    backgroundColor: theme.palette.primary.light,
                    opacity: 0.8,
                  },
                }}
                selected={getSelected(question.key, t('ID_GENERIC_YES'))}
              >
                {t('ID_GENERIC_YES')}
              </ToggleButton>
            </ToggleButtonGroup>
          </Grid>
        );
      })}
    </>
  );
}
